'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Preloader from '@/features/preloader/components/Preloader';
import GroupCard from './GroupCard';
import GroupShoppingProductCard from './GroupShoppingProductCard';
import Link from 'next/link';
import { API_GROUPS, API_USER_SHIPPING_ADDRESS } from '@/constant/apiRout';

export default function GroupShopping() {
  const { data: products, isLoading } = useFetcherCSR(
    `/api/v2/groups/products`
  );
  const { data: address } = useFetcherCSR(API_USER_SHIPPING_ADDRESS);
  const { data, isLoading: isLoading2 } = useFetcherCSR(API_GROUPS);

  // Swiper settings
  const swiperSettings = {
    loop: true,
    modules: [Navigation, Autoplay],
    spaceBetween: 30,
    navigation: true,
    breakpoints: {
      576: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      992: { slidesPerView: 3 },
      1200: { slidesPerView: 4 },
    },
  };

  const scrollToSection = (sectionId: string) => {
    if (typeof window === 'undefined') return;
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (isLoading || isLoading2) {
    return <Preloader />;
  }

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <Link href="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Group Shopping
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <main className="main about ">
        <div
          className="group-shopping padding-top padding-bottom bg-img"
          style={{ backgroundImage: 'url(/images/shop/1.png)' }}
        >
          <div className="container">
            <div className="section-header">
              <div>
                <h2>Why shop alone ?</h2>
                <p>When you can shop & save with friends</p>
              </div>
              {data.just_created.length > 0 && (
                <button
                  onClick={() => scrollToSection('group')}
                  className="trk-btn trk-btn--primary font-weight-normal"
                >
                  JOIN TODAY
                </button>
              )}
            </div>

            <div className="position-relative">
              <Swiper {...swiperSettings} className="products-slider">
                {products.data.map((product: any, index: number) => (
                  <SwiperSlide key={`product-${index}`}>
                    <GroupShoppingProductCard
                      product={product}
                      index={index}
                      address={address}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>

        {data.popular.length > 0 && (
          <div className="popular-group padding-top">
            <div className="container">
              <div className="section-header style2">
                <h2>Most popular group</h2>
              </div>
              <div className="position-relative">
                <Swiper {...swiperSettings} className="products-slider">
                  {data.popular.map((group: any) => (
                    <SwiperSlide key={`popular-${group.id}`}>
                      <GroupCard group={group} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        )}

        {data.just_created.length > 0 && (
          <div id="group" className="new-group padding-bottom padding-top">
            <div className="container">
              <div className="section-header style2">
                <h2>Just created group</h2>
              </div>
              <div className="position-relative">
                <Swiper {...swiperSettings} className="products-slider">
                  {data.just_created.map((group: any) => (
                    <SwiperSlide key={`just-created-${group.id}`}>
                      <GroupCard group={group} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}
